import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { restrictedWordsActions } from ".";
import {
  CLEAR_RESTRICTED_WORDS_STATE,
  FETCH_RESTRICTED_WORDS_LIST_PROGRESS,
  FETCH_RESTRICTED_WORDS_LIST_SUCCESS,
  FETCH_RESTRICTED_WORDS_LIST_FAILED,
} from "./restrictedWordsActions";
import { initialRestrictedWords } from "./defaultState";
import { IRestrictedWords } from "./restrictedWords.types";

export const restrictedWordsReducer = (
  state: IStoreState["restrictedWords"] = initialRestrictedWords,
  action: restrictedWordsActions
) => {
  switch (action.type) {
    case FETCH_RESTRICTED_WORDS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IRestrictedWords) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_RESTRICTED_WORDS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IRestrictedWords) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_RESTRICTED_WORDS_LIST_FAILED: {
      const newState = produce(state, (draftState: IRestrictedWords) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_RESTRICTED_WORDS_STATE: {
      return initialRestrictedWords;
    }
    default:
      return state;
  }
};
